import request from '@/utils/request'
import { DeptType } from './types'

// 创建部门
export function CreateDept(params: {
  name: string
  parentId: number
  deptPrefix: string
  type: DeptType
}) {
  return request({
    url: '/org-admin/dept',
    method: 'post',
    data: params
  })
}

// 更新部门
export function UpdateDept(params: {
  id: number
  name?: string
  parentId?: number
  deptPrefix?: string
  type? :DeptType
}) {
  const { id, ...data } = params
  return request({
    url: `/org-admin/dept/${id}`,
    method: 'put',
    data
  })
}

// 启用部门
export function EnableDept(params: { id: number }) {
  return request({
    url: `/org-admin/enable/dept/${params.id}`,
    method: 'post'
  })
}

// 禁用部门
export function DisableDept(params: { id: number }) {
  return request({
    url: `/org-admin/disable/dept/${params.id}`,
    method: 'post'
  })
}

// 删除部门
export function DeleteDept(params: { id: number }) {
  return request({
    url: `/org-admin/depts/${params.id}`,
    method: 'delete'
  })
}

// 获取部门列表
export function ListDepts() {
  return request({
    url: '/org-admin/depts',
    method: 'get',
  })
}

// 获取部门详情
export function GetDeptById(params: { id: number }) {
  return request({
    url: `/org-admin/dept/${params.id}`,
    method: 'get'
  })
}


// 获取部门成员
export function GetDeptMembers(params: { deptId: number }) {
    return request({
      url: `/org-admin/dept/${params.deptId}/users`,
      method: 'get'
    })
}

// 添加部门成员
export function AddDeptMember(params: {
  deptId: number
  userId: number
  isLeader: boolean
}) {
  const { userId, ...data } = params
  return request({
    url: `/org-admin/dept/user/${userId}`,
    method: 'put',
    data
  })
}

// 移除部门成员
export function RemoveDeptMember(params: {
  deptId: number
  userId: number
}) {
  const { userId, ...data } = params
  return request({
    url: `/org-admin/dept/user/${userId}`,
    method: 'delete',
    data
  })
}

// 修改部门管理状态
export function SetLeaderStatusForDept(params: {
  deptId: number
  userId: number
  isLeader: boolean
}) {
  const { deptId, ...data } = params
  return request({
    url: `/org-admin/dept/set_leader_status/${deptId}`,
    method: 'post',
    data
  })
}

// 将用户添加到租户
export function AddUserToOrg(params: {
  phone?: string
  username?: string
}) {
  return request({
    url: `/org-admin/user`,
    method: 'post',
    data: params
  })
}

// 将用户移出租户
export function RemoveUserFromOrg(params: { userId: number }) {
  return request({
    url: `/org-admin/user/${params.userId}`,
    method: 'delete'
  })
}

// 获取用户列表
export function ListOrgUsers(params?: {
  deptIds?: number[]
  pageNum?: number
  pageSize?: number
  keywords?: string[]
  roleIds?: number[]
  notInDeptIds?: number[]
  }) {
  return request({
    url: '/org-admin/users',
    method: 'get',
    params
  })
}

// 创建角色
export function CreateRole(params: {
  name: string
  desc: string
}) {
  return request({
    url: '/org-admin/role',
    method: 'post',
    data: params
  })
}

// 更新角色
export function UpdateRole(params: {
  id: number
  name?: string
  desc?: string
}) {
  const { id, ...data } = params
  return request({
    url: `/org-admin/role/${id}`,
    method: 'put',
    data
  })
}

// 删除角色
export function DeleteRole(params: { id: number }) {
  return request({
    url: `/org-admin/role/${params.id}`,
    method: 'delete'
  })
}

// 获取角色列表
export function ListRoles() {
  return request({
    url: '/org-admin/roles',
    method: 'get'
  })
}

// 获取角色详情
export function GetRoleById(params: { id: number }) {
  return request({
    url: `/org-admin/role/${params.id}`,
    method: 'get'
  })
}

// 获取所有权限
export function ListPermissions() {
  return request({
    url: '/org-admin/permissions',
    method: 'get'
  })
}

// 给角色分配权限
export function AssignPermissionsToRole(params: {
  roleId: number
  permissions: string[]
}) {
  const { roleId, permissions } = params
  return request({
    url: `/org-admin/role/${roleId}/permissions`,
    method: 'put',
    data: {
      permissions: permissions
    }
  })
}

// 设置角色的数据范围
export function SetRoleDataScope(params: {
  roleId: number
  dataScope: number
  deptIds?: number[]
}) {
  const { roleId, ...data } = params
  return request({
    url: `/org-admin/role/${roleId}/data-scope`,
    method: 'put',
    data
  })
}

// 用户角色分配
export function AssignRolesToUser(params: {
  userId: number
  roleIds: number[]
}) {
  const { userId, roleIds } = params
  return request({
    url: `/org-admin/user/${userId}/roles`,
    method: 'put',
    data: {
      role_ids: roleIds
    }
  })
}

// 项目管理相关接口
export function CreateProject(params: {
  name: string
  prefix: string
  deptId: number
}) {
  return request({
    url: '/org-admin/project',
    method: 'post',
    data: params
  })
}

export function UpdateProject(params: {
  id: number
  name?: string
  prefix?: string
  deptId?: number
}) {
  const { id, ...data } = params
  return request({
    url: `/org-admin/project/${id}`,
    method: 'put',
    data
  })
}

export function EnableProject(params: { id: number }) {
  return request({
    url: `/org-admin/enable/project/${params.id}`,
    method: 'post'
  })
}

export function DisableProject(params: { id: number }) {
  return request({
    url: `/org-admin/disable/project/${params.id}`,
    method: 'post'
  })
}

export function ListProjects(params?: {
  onlyEnabled?: boolean
}) {
  return request({
    url: '/org-admin/projects',
    method: 'get',
    params
  })
}
